export const padStart = n => (n < 10 ? '0' : '') + n;
